const MAX_BUFFERED_CSP_VIOLATIONS = 50;

export function createCspViolationBuffer(eventTarget) {
  const bufferedViolations = [];
  const fingerprints = new Set();
  let isListening = true;

  const handleViolation = (event) => {
    const violation = {
      blockedURI: event.blockedURI,
      disposition: event.disposition,
      effectiveDirective: event.effectiveDirective,
      violatedDirective: event.violatedDirective,
    };
    const fingerprint = JSON.stringify(violation);

    if (
      fingerprints.has(fingerprint) ||
      fingerprints.size >= MAX_BUFFERED_CSP_VIOLATIONS
    ) {
      return;
    }

    fingerprints.add(fingerprint);
    bufferedViolations.push(violation);
  };

  const stopListening = () => {
    if (!isListening) {
      return;
    }

    eventTarget.removeEventListener('securitypolicyviolation', handleViolation);
    isListening = false;
  };

  eventTarget.addEventListener('securitypolicyviolation', handleViolation);

  return {
    discard() {
      stopListening();
      bufferedViolations.length = 0;
      fingerprints.clear();
    },
    drain(reportViolation) {
      stopListening();
      bufferedViolations.splice(0).forEach(reportViolation);
      fingerprints.clear();
    },
  };
}

const initialCspViolationBuffer =
  typeof document === 'undefined' ? null : createCspViolationBuffer(document);

export function discardInitialCspViolationBuffer() {
  initialCspViolationBuffer?.discard();
}

export function drainInitialCspViolationBuffer(reportViolation) {
  initialCspViolationBuffer?.drain(reportViolation);
}
